import {ArrowUpRight, CheckCircle2, Mail} from '@nlabs/gothamjs/icons';
import {Link} from '@nlabs/gothamjs/router';

import {authLink} from './authClasses.js';
import {getDemoDeliveryHref} from './authContent.js';

import type {ReactElement} from 'react';
import type {AuthMode, AuthResult} from '../../state/authActions.js';

interface AuthFeedbackProps {
  readonly mode: AuthMode;
  readonly result: AuthResult;
}

export const AuthFeedback = ({mode, result}: AuthFeedbackProps): ReactElement => {
  const demoHref = getDemoDeliveryHref(result);
  const canSignIn = ['verify-email', 'reset-password', 'sign-out'].includes(mode);
  let heading = 'Request complete.';
  if(mode === 'verify-email') {
    heading = 'Email verified.';
  } else if(mode === 'reset-password') {
    heading = 'Password updated.';
  } else if(mode === 'sign-out') {
    heading = 'You’re signed out.';
  } else if(mode === 'sign-up') {
    heading = 'Check your verification link.';
  }
  return (
    <div className="space-y-5" role="status">
      <div className="rounded-2xl border border-white/50 bg-white/30 p-5">
        <CheckCircle2 aria-hidden="true" className="mb-3 text-sky-800" size={24} />
        <h2 className="text-lg font-semibold text-slate-950">{heading}</h2>
        <p className="mt-2 text-sm leading-6 text-slate-700">{result.message || 'Your request was completed.'}</p>
      </div>
      {demoHref && (
        <div className="rounded-2xl border border-violet-600/20 bg-white/25 p-5">
          <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-violet-950">
            <Mail aria-hidden="true" size={17} />Local email preview
          </div>
          <p className="text-sm leading-6 text-slate-700">No email was sent. Use this link only in this local demo.</p>
          <Link className={`${authLink} mt-4 gap-2 underline`} to={demoHref}>
            {result.demoDelivery?.kind === 'verification' ? 'Open verification link' : 'Open reset link'}
            <ArrowUpRight aria-hidden="true" size={16} />
          </Link>
        </div>
      )}
      {canSignIn && <Link className={`${authLink} w-full justify-center rounded-full border border-sky-900/20 bg-white/25 px-5 py-3 hover:bg-white/40`} to="/sign-in">Continue to sign in</Link>}
    </div>
  );
};
